module.exports = __webpack_public_path__ + "assets/img/cpys3.5588f4d4.jpg";